import iconsObj from 'common/src/assets/icons/iconsObj';
import _capitalize from 'lodash/capitalize';
import {
  AnalyticsEventType,
  AnalyticsUiNameMapping,
  CompatibilityGroupData,
  DimensionValue,
  InsightsMetricSelectOption,
  MetricsAction,
  MetricsChartType,
  MetricsGroupBy,
  MetricValue,
} from './analytics.types';

export const NOT_EXISTED_PREFIX = 'No ';
export const MAX_CHART_LABELS_BY_DATE_AMOUNT = 31;
export const MAX_CHART_LABELS_BY_WEEK_AMOUNT = 7;
export const MAX_CHART_LABELS_BY_MONTH_AMOUNT = 12;
export const LS_DASHBOARD_WIDGET_PARAMS = 'dashboard_widget_params';
export const LS_METRICS_PARAMS = 'metics_params';
export const CUSTOM_METRIC_PREFIX = 'custom_';
export const COLOR_PALETTE = ['#2478BE', '#44A89C', '#E9C46A', '#F4A261', '#E76F51'];
export const DEFAULT_DASHBOARD_ID = -5;

export const PERCENT_METRIC_TYPES: MetricValue[] = [
  MetricValue.ConversionRate,
  MetricValue.ClickThroughRate,
  MetricValue.Viewability,
  MetricValue.VideoCompletionRate,
  MetricValue.ExternalTotalConversionRate,
  MetricValue.CTCR,
  MetricValue.VTCR,

  MetricValue.VideoQ1Rate,
  MetricValue.VideoQ2Rate,
  MetricValue.VideoQ3Rate,
];

export const FINANCE_METRICS_TYPES = [
  MetricValue.Sales,
  MetricValue.CPC,
  MetricValue.CPA,
  MetricValue.Cost,
  MetricValue.CPM,
];

export const DEFAULT_VIEW_BY_OPTION: InsightsMetricSelectOption<DimensionValue> = {
  label: 'Date',
  value: DimensionValue.Date,
};

export const DIMENSIONS_WITH_THUMBNAILS = [DimensionValue.Creative, DimensionValue.Ad];
export const FILTER_STRING_VALUES_TYPE = [DimensionValue.Product];
export const DATE_DIMENSIONS = [
  DimensionValue.Date,
  DimensionValue.TimeOfDay,
  DimensionValue.DayOfWeek,
  DimensionValue.Month,
];

export const FILTER_LOV_VALUES_TYPE = [
  DimensionValue.DSP,
  DimensionValue.Store,
  DimensionValue.Product,
  DimensionValue.UserDMA,
  DimensionValue.AdFormat,
  DimensionValue.Campaign,
  DimensionValue.Creative,
  DimensionValue.UserCity,
  DimensionValue.UserState,
  DimensionValue.Placement,
  DimensionValue.CreativeID,
  DimensionValue.CampaignID,
  DimensionValue.StoreGroup,
  DimensionValue.ProductID,
  DimensionValue.ProductName,
  DimensionValue.UserZipCode,
  DimensionValue.PlacementID,
  DimensionValue.UserCountry,
  DimensionValue.CreativeName,
  DimensionValue.CampaignType,
  DimensionValue.CampaignName,
  DimensionValue.ProductTitle,
  DimensionValue.DSPSegmentId,
  DimensionValue.PlacementName,
  DimensionValue.DSPStrategyId,
  DimensionValue.AdId,
  DimensionValue.AdSet,
  DimensionValue.AdSetId,
  DimensionValue.ExternalCampaignName,
  DimensionValue.Device,
  DimensionValue.AttributionSignalID,
  DimensionValue.AttributionSignalName,

  DimensionValue.CampaignTagOne,
  DimensionValue.CampaignTagTwo,
  DimensionValue.CampaignTagThree,
  DimensionValue.CreativeTagOne,
  DimensionValue.CreativeTagTwo,
  DimensionValue.CreativeTagThree,
  DimensionValue.CreativeTemplateId,
  DimensionValue.Attribution,
  DimensionValue.AttributionSignalID,
  DimensionValue.AttributionSignalName,
  DimensionValue.DSPCampaignID,
  DimensionValue.PlacementCustomOne,
  DimensionValue.PlacementCustomTwo,
  DimensionValue.PlacementCustomThree,
  DimensionValue.ClientID,
  DimensionValue.ClientName,
  DimensionValue.Client,
  DimensionValue.StoreID,
  DimensionValue.StoreName,
  DimensionValue.ConversionType,
];

export const SPECIAL_VIEW_BY_TYPES: DimensionValue[] = [
  DimensionValue.Product,
  DimensionValue.Creative,
  DimensionValue.Campaign,
  DimensionValue.Placement,
  DimensionValue.Attribution,
  DimensionValue.Ad,
  DimensionValue.AdSet,
  DimensionValue.Store,
  DimensionValue.Client,
  DimensionValue.CartOutputId,
];

export const SPECIAL_DIMENSION_BY_VIEW_BY: Record<string, [DimensionValue, DimensionValue]> = {
  [DimensionValue.Product]: [DimensionValue.ProductID, DimensionValue.ProductName],
  [DimensionValue.Campaign]: [DimensionValue.CampaignID, DimensionValue.CampaignName],
  [DimensionValue.Creative]: [DimensionValue.CreativeID, DimensionValue.CreativeName],
  [DimensionValue.Placement]: [DimensionValue.PlacementID, DimensionValue.PlacementName],
  [DimensionValue.Attribution]: [
    DimensionValue.AttributionSignalID,
    DimensionValue.AttributionSignalName,
  ],
  [DimensionValue.Ad]: [DimensionValue.AdId, DimensionValue.AdName],
  [DimensionValue.AdSet]: [DimensionValue.AdSetId, DimensionValue.AdSetName],
  [DimensionValue.Store]: [DimensionValue.StoreID, DimensionValue.StoreName],
  [DimensionValue.Client]: [DimensionValue.ClientID, DimensionValue.ClientName],
  [DimensionValue.CartOutputId]: [DimensionValue.CartOutputId, DimensionValue.CartOutputName],
};

export const REMOTE_METRICS_GROUP_BY: Partial<Record<MetricsGroupBy, DimensionValue>> = {
  [MetricsGroupBy.Day]: DimensionValue.Date,
  [MetricsGroupBy.Week]: DimensionValue.Week,
  [MetricsGroupBy.Month]: DimensionValue.Month,
  [MetricsGroupBy.ConvDate]: DimensionValue.ConversionDate,
};

export const METRICS_GROUP_BY_OPTIONS = [
  {
    value: MetricsGroupBy.Day,
    label: _capitalize(MetricsGroupBy.Day),
  },
  {
    value: MetricsGroupBy.Week,
    label: _capitalize(MetricsGroupBy.Week),
  },
  {
    value: MetricsGroupBy.Month,
    label: _capitalize(MetricsGroupBy.Month),
  },
];

export const ACTIONS_OPTIONS = [
  {
    value: MetricsAction.SaveView,
    label: MetricsAction.SaveView,
  },
  {
    value: MetricsAction.ExportToPDF,
    label: MetricsAction.ExportToPDF,
  },
  {
    value: MetricsAction.ExportToCSV,
    label: MetricsAction.ExportToCSV,
  },
];

export const MAX_METRICS = 2;
export const MIN_METRICS = 1;

export const chartTypeOptions = [
  {
    value: MetricsChartType.Line,
    label: 'Line',
    icon: iconsObj.metricsPage.charts[MetricsChartType.Line],
    maxMetrics: MAX_METRICS,
  },
  {
    value: MetricsChartType.Area,
    label: 'Area Line',
    icon: iconsObj.metricsPage.charts[MetricsChartType.Area],
    maxMetrics: MAX_METRICS,
  },
  {
    value: MetricsChartType.Bar,
    label: 'Stacked Bar',
    icon: iconsObj.metricsPage.charts[MetricsChartType.Bar],
    maxMetrics: MAX_METRICS,
  },
  {
    value: MetricsChartType.HorizontalBar,
    label: 'Horizontal Bar',
    icon: iconsObj.metricsPage.charts[MetricsChartType.HorizontalBar],
    maxMetrics: MIN_METRICS,
  },
  {
    value: MetricsChartType.PieChart,
    label: 'Pie Chart',
    icon: iconsObj.metricsPage.charts[MetricsChartType.PieChart],
    maxMetrics: MIN_METRICS,
  },
];

export const ATTRIBUTION_DIMENSIONS = [
  DimensionValue.Attribution,
  DimensionValue.AttributionSignalID,
  DimensionValue.AttributionSignalName,
];

export const LINE_BAR_WIDGET_COLOR_PALETTE = [
  '#2478BE',
  '#F4A261',
  '#44A89C',
  '#6C5DD3',
  '#E9C46A',
  '#E76F51',
  '#6C5DD3',
  '#0049C6',
  '#FFA2C0',
  '#FFCE73',
  '#A4C639',
  '#FFB7F5',
  '#3F8CFF',
  '#A0D7E7',
  '#CDF4FF',
  '#FF754C',
];

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const DONUT_WIDGET_COLOR_PALETTE = ['#0049C6', '#3F8CFF', '#A0D7E7', '#CDF4FF', '#FF754C'];

export const NO_DIMENSION = 'No Value';

export const advertiserMetrics = [
  MetricValue.Impressions,
  MetricValue.Clicks,
  MetricValue.Conversions,
  MetricValue.Roas,
];

export const customAnalyticsUINameMapping: AnalyticsUiNameMapping = {
  [MetricValue.CustomConversions]: 'Custom Conversions',
  [MetricValue.CustomMetaConversions]: 'Meta Custom Conversion',
};

export const ANALYTICS_LIMIT = 10000;

export const contentFeedDimensionPrefix = 'content_';

export const eventTypeOptionsForSelectors = [
  {
    label: 'Ad Engagement events',
    value: AnalyticsEventType.Adserving,
  },
  {
    label: 'Website/App/Offline 1st party events',
    value: AnalyticsEventType.Website,
  },
];

export const MAX_TABS = 10;

export const DIMENSIONS_WITHOUT_FILTERING = [
  DimensionValue.Date,
  DimensionValue.CampaignTagOne,
  DimensionValue.CampaignTagTwo,
  DimensionValue.CampaignTagThree,
  DimensionValue.CreativeTagOne,
  DimensionValue.CreativeTagTwo,
  DimensionValue.CreativeTagThree,
  DimensionValue.PlacementCustomOne,
  DimensionValue.PlacementCustomTwo,
  DimensionValue.PlacementCustomThree,
  DimensionValue.CreativeTemplateId,
  DimensionValue.TimeOfDay,
  DimensionValue.DayOfWeek,
  DimensionValue.AdSetName,
  DimensionValue.AdName,
];

export const SHORT_METRIC_NAME: Partial<Record<MetricValue | DimensionValue, string>> = {
  [MetricValue.ConversionRate]: 'CR',
  [MetricValue.ClickThroughRate]: 'CTR',
  [MetricValue.ViewThroughConversions]: 'VTC',
  [MetricValue.ClickThroughConversion]: 'CTC',
  [MetricValue.VideoCompletionRate]: 'VCR',
  [MetricValue.CTCR]: 'CTCR',
  [MetricValue.VTCR]: 'VTCR',
};

export const DEFAULT_COMPATIBILITY_GROUPS = {
  [AnalyticsEventType.Adserving]: [] as CompatibilityGroupData[],
  [AnalyticsEventType.Website]: [] as CompatibilityGroupData[],
};
